﻿import { SaopViewForm } from "../Core/saop-view-form";
import { SaopUploadFiles } from "../Components/saop-upload-files";
import { SaopAttachmentList } from "../Components/saop-attachment-list";

export class OPNPotniNalogiView extends SaopViewForm {
  private _formId:string;
  private _saopUploadFiles:SaopUploadFiles;
  private _saopAttachmentList: SaopAttachmentList;

  constructor(viewId:string,libName:string = ""){
    super(viewId,libName);
    this.title = this.translationService.translate("Potni nalog");
    this.addRecordEndpoint = "TravelOrder/CreateTravelOrder";
    this.editRecordEndpoint = "TravelOrder/EditTravelOrder";
    this.deleteRecordEndpoint = "TravelOrder/DeleteTravelOrder"; 
    this._saopUploadFiles = new SaopUploadFiles(viewId,libName);  
    //
    this.afterViewShowSuccess = this.LoadViewEvents;
    this.afterSubmitSuccess = this.LoadViewEvents;
    this._saopAttachmentList = new SaopAttachmentList("#travelOrderAttachments", libName + "._saopAttachmentList");
    this._saopAttachmentList.initComponent(
      {
          validationFingerprintController: "SPLDocument",
          validationFingerprintAction: "ValidateAttachmentFingerPrint",
          validationFingerprintBannerDivId: viewId + " #uploadFilesValidationsAjax",
          validationController: "SPLDocument",
          validationAction: "ValidateDownloadingDocumentAttachment",
          validationBannerDivId: viewId + " #uploadFilesValidationsAjax",
          downloadController: "SPLDocument",
          downloadAction: "DownloadDocumentAttachment",
          deletedAttachmentListId: viewId + " " + "#PriponkeBrisane"
      });

  }

  setDictionary(){
      let dictionary:string[] = ["Potni nalog","Brisanje","Ali ste prepričani, da želite izbrisati dogodek?"];
      this.setTerminologyList(dictionary);
  } 
  
  public deleteRecord(deleteData:any):void{
    let deletTitle = this.translationService.translate("Brisanje");
    let deleteMessage = this.translationService.translate("Ali ste prepričani, da želite izbrisati dogodek?");    
    super.deleteRecord(deletTitle,deleteMessage,deleteData);
  }  

  public afterViewShowSuccess(sender:any):void{
    this.LoadViewEvents();
  }

  public LoadViewEvents ():void{
    let _viewDiv = $(this.id);
    if (_viewDiv.length == 0) {return;}

    let _this = this;
    this._formId = "#detailsOPNPotniNalogiFullForm";
    this._saopUploadFiles.initComponent({controller:"TravelOrder",action:"ValidateFiles",validateAjax:true,formId:this._formId,validationDivId:"#uploadFilesValidationsAjax"});
    this._saopUploadFiles.afterRefreshFilesList = this._saopUploadFiles.ajaxValidate;

    $('#btnOk').off('click');
    $('#btnOk').bind('click', 
      function() {
        let _result = _this._saopUploadFiles.ajaxValidate();
        return _result;        
      }          
    );    

    $('#PredvideniCasOdhoda').off('focusout',this.onFocusOutPredvideniCasOdhoda.bind(this));
    $("#PredvideniCasOdhoda").bind('focusout',this.onFocusOutPredvideniCasOdhoda.bind(this));

    $('#btnCheckIn').off('click');
    $('#btnCheckIn').bind('click', 
      function(e) {
        _this.ChechIn();    
      }          
    );  

    // $(this._formId).submit(function(e){
    //   let _sender = e.target;
    //   //$('#CheckIn').val('true');
    // });    
    
    $('#OdobrenaUporaba').off('change');
    $('#OdobrenaUporaba').on('change', _this.onChangeOdobrenaUporaba.bind(this)); 
    $('#OdobrenaUporaba').change();

    $('#SifraRelacije').off('change');
    $('#SifraRelacije').on('change', _this.onChangeSifraRelacije.bind(this)); 
    $('#SifraRelacije').change();

    $('#SifraNaloge').off('change');
    $('#SifraNaloge').on('change', _this.onChangeSifraNaloge.bind(this)); 
    $('#SifraNaloge').change();

    this._saopAttachmentList.initWebGridListners();
  }

  public ChechIn():void {
    $('#CheckIn').val('true');
  }

  onFocusOutPredvideniCasOdhoda(e:any):void{
    if(!$("#PredvideniCasPrihoda").val()) {
      $("#PredvideniCasPrihoda").val($("#PredvideniCasOdhoda").val());
    }
  }

  onChangeOdobrenaUporaba(e:any):void{
    let _selectedValue = e.target.value;  
    let _registrskaStevilkaPredlogGroup = $('#RegistrskaStevilkaPredlogGroup');
    if (_selectedValue == '1') {
      _registrskaStevilkaPredlogGroup.show();
    } else {
      _registrskaStevilkaPredlogGroup.hide();
    }
  }

  onChangeSifraRelacije(e:any):void {
    let _selectedValue = e.target.value;  
    let _privzetaSifraRelacije = $('#PrivzetaSifraRelacije').val();
    if (_selectedValue == _privzetaSifraRelacije) {
      this.saopFloatingLabel.setCaptionAsRequired("#lblDodatniOpisRelacije",true);
    } else {
      this.saopFloatingLabel.setCaptionAsRequired("#lblDodatniOpisRelacije",false);
      $("#DodatniOpisRelacije").focusout();      
    }
  }


  onChangeSifraNaloge(e:any):void{
    let _selectedValue = e.target.value;  
    let _privzetaSifraNaloge = $('#PrivzetaSifraNaloge').val();
    if (_selectedValue == _privzetaSifraNaloge) {
      this.saopFloatingLabel.setCaptionAsRequired("#lblDodatniOpisNaloge",true);
    } else {
      this.saopFloatingLabel.setCaptionAsRequired("#lblDodatniOpisNaloge",false);
      $("#DodatniOpisNaloge").focusout();
    }
  }

  //
}






